
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";

@Component({
  components: {
    UiButton,

  },
})
export default class InvoiceHeader extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: null }) readonly subtitle!: string | null;
  @Prop({ default: false }) readonly showBtn!: string | null;
  @Prop({ default: "Create" }) readonly btnText!: string | null;
  @Prop({ default: "" })  btnClass?: string | null;

  handleClick(e) {
    this.$emit("btn-clicked", e);
  }
}
